var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "render-post",
      staticClass: "container-render-post",
      style: { fontSize: _vm.fontSize + "px" },
    },
    [
      _c(
        "div",
        { staticClass: "render-post hide-scrollbar render-post-facebook" },
        [
          _c(
            "div",
            { staticClass: "post-content" },
            [
              _c("div", { staticClass: "post-header" }, [
                _c(
                  "div",
                  { staticClass: "img-pages" },
                  [
                    _vm._l(
                      _vm.pages.slice(0, _vm.pages.length == 4 ? 4 : 3),
                      function (page, index) {
                        return [
                          _c(
                            "Tooltip",
                            {
                              key: index,
                              attrs: {
                                active: page.iconEdited,
                                text: "Voir les modifications apportées",
                                position: "right",
                                classCustom: `page ${
                                  page.iconEdited ? "iconEdited" : ""
                                }`,
                              },
                              on: {
                                click: () => {
                                  page.iconEdited
                                    ? _vm.$emit("clickPage", page.id)
                                    : _vm.openFacebookPage(page)
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src:
                                    page && page.avatar
                                      ? page.avatar
                                      : "img/avatar.jpg",
                                  alt: "",
                                },
                              }),
                            ]
                          ),
                        ]
                      }
                    ),
                    _vm.pages.length > 4
                      ? _c("div", { staticClass: "page count" }, [
                          _vm._v(
                            "\n                        +" +
                              _vm._s(_vm.pages.length - 3) +
                              "\n                    "
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
                _c("div", { staticClass: "info" }, [
                  _c("div", { staticClass: "info-top" }, [
                    _vm.pages.length == 1
                      ? _c(
                          "p",
                          {
                            staticClass: "name",
                            on: {
                              click: function ($event) {
                                return _vm.openFacebookPage(_vm.pages[0])
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.pages[0].name) + " ")]
                        )
                      : _vm._e(),
                    _vm.place && _vm.place.name
                      ? _c("p", { staticClass: "location" }, [
                          _vm._v(
                            _vm._s(_vm.$t("dash.post-creator.render.is-at")) +
                              " "
                          ),
                          _c("span", { staticClass: "value" }, [
                            _vm._v(_vm._s(_vm.place.name)),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                  _c("div", { staticClass: "date" }, [
                    _vm._v(
                      _vm._s(
                        _vm.datePost ? _vm.dateFormatPost : "A l'instant"
                      ) + " • "
                    ),
                    _c("i", { staticClass: "fa-solid fa-earth-americas" }),
                  ]),
                ]),
                _vm._m(0),
              ]),
              _vm.text
                ? _c("div", { staticClass: "post-text" }, [
                    _c("p", {
                      domProps: { innerHTML: _vm._s(_vm.textTranslate) },
                    }),
                  ])
                : _vm._e(),
              _vm.snippet.link
                ? _c(
                    "div",
                    { staticClass: "snippet" },
                    [
                      _c("SnippetNetwork", {
                        attrs: {
                          link: _vm.snippet.link,
                          titleDefault: _vm.snippet.title,
                          imageUrlDefault: _vm.snippet.imageUrl,
                          descriptionDefault: _vm.snippet.description,
                        },
                      }),
                    ],
                    1
                  )
                : _vm.isMixedMedia
                ? _c("div", { staticClass: "post-medias-carousel" }, [
                    _vm.medias.length == 1
                      ? _c("div", { staticClass: "media" }, [
                          _vm.medias[0].type.startsWith("video/")
                            ? _c(
                                "div",
                                {
                                  staticClass: "media-video",
                                  class: {
                                    videoPlayed:
                                      _vm.videoPlayed == _vm.medias[0].id,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.togglePlayPause(
                                        _vm.medias[0].id
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm.getThumbnailUrl(_vm.medias[0]) &&
                                  _vm.videoPlayed !== _vm.medias[0].id
                                    ? _c("img", {
                                        staticClass: "imagePreview",
                                        attrs: {
                                          src: _vm.getThumbnailUrl(
                                            _vm.medias[0]
                                          ),
                                          alt: "",
                                        },
                                      })
                                    : _vm._e(),
                                  _c("video", {
                                    ref: "videoPlayer",
                                    staticClass: "video",
                                    attrs: {
                                      mediaId: _vm.medias[0].id,
                                      playsinline: "",
                                      preload: "metadata",
                                      loop: "",
                                      autoPlay:
                                        _vm.videoPlayed == _vm.medias[0].id,
                                      src: _vm.medias[0].url,
                                      type: _vm.medias[0].type,
                                    },
                                  }),
                                ]
                              )
                            : _c("img", {
                                attrs: { src: _vm.medias[0].url, alt: "" },
                              }),
                        ])
                      : _c(
                          "div",
                          {
                            staticClass: "carousel hide-scrollbar",
                            on: { wheel: _vm.handleHorizontalScroll },
                          },
                          _vm._l(_vm.medias.slice(0, 20), function (media, i) {
                            return _c(
                              "div",
                              {
                                key: media.id,
                                staticClass: "item",
                                class: { ["item" + i]: true },
                              },
                              [
                                media.info.type.startsWith("video/")
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "media-video",
                                        class: {
                                          videoPlayed:
                                            _vm.videoPlayed == media.id,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.togglePlayPause(media.id)
                                          },
                                        },
                                      },
                                      [
                                        _vm.getThumbnailUrl(media) &&
                                        _vm.videoPlayed !== media.id
                                          ? _c("img", {
                                              staticClass: "imagePreview",
                                              attrs: {
                                                src: _vm.getThumbnailUrl(media),
                                                alt: "",
                                              },
                                            })
                                          : _vm._e(),
                                        _c("video", {
                                          ref: "videoPlayer",
                                          refInFor: true,
                                          staticClass: "video",
                                          attrs: {
                                            mediaId: media.id,
                                            playsinline: "",
                                            preload: "metadata",
                                            loop: "",
                                            autoPlay:
                                              _vm.videoPlayed == media.id,
                                            src: media.url,
                                            type: media.info.type,
                                          },
                                        }),
                                      ]
                                    )
                                  : _c("img", {
                                      attrs: { src: media.url, alt: "" },
                                    }),
                              ]
                            )
                          }),
                          0
                        ),
                  ])
                : _vm.medias.filter((media) => media).length
                ? _c(
                    "div",
                    { class: "post-medias media" + _vm.medias.length },
                    _vm._l(_vm.medias.slice(0, 4), function (media, i) {
                      return media
                        ? _c("div", { key: media.id, staticClass: "media" }, [
                            i == 3 && _vm.medias.length > 4
                              ? _c("div", { staticClass: "count" }, [
                                  _vm._v("+" + _vm._s(_vm.medias.length - 3)),
                                ])
                              : _vm._e(),
                            media.info.type.startsWith("video/")
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "media-video",
                                    class: {
                                      videoPlayed: _vm.videoPlayed == media.id,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.togglePlayPause(media.id)
                                      },
                                    },
                                  },
                                  [
                                    media.imagePreview &&
                                    _vm.videoPlayed !== media.id
                                      ? _c("img", {
                                          staticClass: "imagePreview",
                                          attrs: {
                                            src: media.imagePreview.url,
                                            alt: "",
                                          },
                                        })
                                      : _vm._e(),
                                    _c("video", {
                                      ref: "videoPlayer",
                                      refInFor: true,
                                      staticClass: "video",
                                      attrs: {
                                        mediaId: media.id,
                                        playsinline: "",
                                        preload: "metadata",
                                        loop: "",
                                        autoPlay: _vm.videoPlayed == media.id,
                                        src: media.url,
                                        type: media.info.type,
                                      },
                                    }),
                                  ]
                                )
                              : _c("img", {
                                  attrs: { src: media.url, alt: "" },
                                }),
                          ])
                        : _vm._e()
                    }),
                    0
                  )
                : _vm._e(),
              !_vm.text && !_vm.medias.length && !_vm.snippet.link
                ? _c("div", { staticClass: "post-empty" })
                : _vm._e(),
              _vm._m(1),
              _vm._l(_vm.commentsTranslate, function (comment) {
                return _c("div", { staticClass: "comment-first" }, [
                  _c("img", {
                    attrs: {
                      src:
                        !_vm.pages ||
                        !_vm.pages.length ||
                        _vm.pages.length > 1 ||
                        !_vm.pages[0]
                          ? "img/avatar.jpg"
                          : _vm.pages[0].avatar,
                      alt: "",
                    },
                  }),
                  _c("div", { staticClass: "content-comment" }, [
                    _vm._m(2, true),
                    _vm.pages.length == 1
                      ? _c("p", { staticClass: "page-name" }, [
                          _vm._v(_vm._s(_vm.pages[0].name)),
                        ])
                      : _vm._e(),
                    _c("p", {
                      staticClass: "comment",
                      domProps: { innerHTML: _vm._s(comment) },
                    }),
                  ]),
                ])
              }),
            ],
            2
          ),
        ]
      ),
      _vm.modes.includes("addPlaceMode")
        ? _c("SelectPlace", {
            attrs: {
              placeSelected: _vm.place,
              position: _vm.positionFormOverlay,
              network: "facebook",
            },
            on: { close: _vm.closeContentOverflow },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "more" }, [
      _c("i", { staticClass: "fa-solid fa-ellipsis" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "post-footer" }, [
      _c("div", { staticClass: "reaction" }, [
        _c("i", { staticClass: "fa-regular fa-thumbs-up" }),
        _vm._v("\n                    J'aime\n                "),
      ]),
      _c("div", { staticClass: "comments" }, [
        _c("i", { staticClass: "fa-regular fa-comment" }),
        _vm._v("\n                    Commenter\n                "),
      ]),
      _c("div", { staticClass: "share" }, [
        _c("i", { staticClass: "fa-regular fa-share" }),
        _vm._v("\n                    Partager\n                "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "auteur" }, [
      _c("i", { staticClass: "fa-solid fa-microphone-stand" }),
      _vm._v("Auteur"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }